import { render, staticRenderFns } from "./Exercise.vue?vue&type=template&id=08f66be3&scoped=true"
import script from "./Exercise.vue?vue&type=script&lang=js"
export * from "./Exercise.vue?vue&type=script&lang=js"
import style0 from "./Exercise.vue?vue&type=style&index=0&id=08f66be3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f66be3",
  null
  
)

export default component.exports